"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.PUT = exports.DELETE = exports.POST = exports.GET = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
exports.GET = "GET";
exports.POST = "POST";
exports.DELETE = "DELETE";
exports.PUT = "PUT";
class HttpClient {
    constructor() {
        this.instance = axios_1.default.create({ withCredentials: true });
    }
    send(endpoint, method, headers, data, params) {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (headers != undefined) {
                headers["Access-Control-Allow-Credentials"] = true;
            }
            try {
                const resp = yield this.instance.request({
                    method,
                    url: endpoint,
                    headers,
                    data,
                    params
                });
                return resp;
            }
            catch (err) {
                if (axios_1.default.isAxiosError(err)) {
                    if (err.response) {
                        const errPayload = {
                            error: "request error",
                            status: (_a = err.response) === null || _a === void 0 ? void 0 : _a.status,
                            statusText: (_b = err.response) === null || _b === void 0 ? void 0 : _b.statusText,
                            data: (_c = err.response) === null || _c === void 0 ? void 0 : _c.data,
                        };
                        console.error("request error", errPayload);
                        throw new Error(JSON.stringify(errPayload));
                    }
                    else {
                        const errPayload = { error: "connection error" };
                        console.error("connection error", errPayload);
                        throw new Error(JSON.stringify(errPayload));
                    }
                }
                throw new Error(JSON.stringify({ error: err }));
            }
        });
    }
}
exports.HttpClient = HttpClient;
